export enum BmButtons {
  EDIT,
  CANCEL,
  CREATE,
  UPDATE,
  ADD_NEW_MODEL,
  DUPLICATE,
  DELETE,
}

export enum BmInputAction {
  EDIT,
  CANCEL,
  SAVE,
}

export enum BmCalcType {
  GENERATED = 'GENERATED',
  MANUAL = 'MANUAL',
  CALCULATED = 'CALCULATED'
}

export enum BmDataFillingType {
  YEARLY = 'Annual',
  QUARTERLY = 'Quarterly',
  MONTHLY = 'Monthly',
  MANUAL = 'Manual'
}

export enum BmGroupAction {
  ADD = 'ADD',
  DELETE = 'DELETE',
  DUPLICATE = 'DUPLICATE',
  RENAME = 'RENAME',
  RENAME_SAVE = 'RENAME_SAVE',
  RENAME_CANCEL = 'RENAME_CANCEL',
}

export enum BmGroupType {
  MGM_FEE_PCNT= 'MGM_FEE_PCNT',
  EXPENSES = 'EXPENSES',
  INVESTMENT_VALUE = 'INVESTMENT_VALUE',
  INVESTMENT_PCNT = 'INVESTMENT_PCNT'
}

export enum BmValidationErrors {
  MUST_STAY_DISABLED = 'mustStayDisabled',
  MAX = 'max'
}

